import React from 'react';
import * as S from './BkngActions.styles';

import IconSelector from '@ibibo/icon-selector';

const BkngActions = ({actions}) => {
  if (!actions.length) {
    return null;
  }

  return(
    <S.BkngOptionsOuterWrap>
      <S.LeftHalfCircle />
      <S.RightHalfCircle />
      {(actions.map(action => <S.BkngOptionInnerWrap onClick={() => {
        window.open(action.link, '_blank')
      }} key={action.title}>
        <S.BkngOptionWrap>
          <S.BkngOptionIconWrap>
            <IconSelector iconKey={`${action.icon}`} />
          </S.BkngOptionIconWrap>
        </S.BkngOptionWrap>
        <S.BkngOptionText>{action.title}</S.BkngOptionText>
      </S.BkngOptionInnerWrap>)) || null}
    </S.BkngOptionsOuterWrap>
  );
}

export default BkngActions;